import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Opens a status-tabbed list on a tab, e.g. `/care-management/patients?status=ENROLLED`. */
export const STATUS_TAB_PARAM = 'status';

/**
 * Selects the tab named by `?status=` once it exists, then drops the param so the page's own
 * tab memory takes over again.
 *
 * Matches on status, not index: which tabs exist depends on feature flags and counts (the
 * unenrolled tab only appears once it has patients), so indices differ between tenants.
 */
const useStatusTabFromUrl = (tabs: { status: string }[], setTab: (index: number) => void) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const wanted = searchParams.get(STATUS_TAB_PARAM);

  useEffect(() => {
    if (!wanted) return;

    const index = tabs.findIndex(tab => tab.status === wanted);
    if (index < 0) return;

    setTab(index);
    setSearchParams(
      params => {
        params.delete(STATUS_TAB_PARAM);
        return params;
      },
      { replace: true }
    );
  }, [wanted, tabs, setTab, setSearchParams]);
};

export default useStatusTabFromUrl;
